import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// Las variables se mantienen sin cambios.
const variables = {
  borderRadius: '16px',
  borderColor: '#e9ecef',
  white: '#ffffff',
  primary: '#007bff',
  text: '#343a40',
  textLight: '#6c757d',
  shadow: '0 4px 4px rgba(0, 0, 0, 1)',
  shadowHeavy: '0 12px 35px rgba(0, 0, 0, 0.25)',
};

export const WidgetContainer = styled(motion.div)<{
  isOtherFocused?: boolean;
  hasInteraction?: boolean;
}>`
  position: relative;
  background-color: ${variables.white};
  border-radius: ${variables.borderRadius};
  padding: clamp(16px, 4vw, 24px); // clamp() ya es responsivo, excelente.
  box-shadow: ${variables.shadow};
  border: 2px solid transparent; 
  cursor: pointer;
  transition: opacity 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
  overflow: hidden;
  
  // ✅ CAMBIO CLAVE: Se reemplaza la altura en porcentaje por una altura fija y adaptable.
  height: 260px; // Altura base para pantallas grandes.

  opacity: ${({ isOtherFocused, hasInteraction }) =>
    isOtherFocused && hasInteraction ? 0.4 : 1};

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: ${variables.borderRadius};
    border: 2px solid ${variables.primary};
    clip-path: circle(0% at 50% 50%);
    transition: clip-path 0.4s ease-in-out;
    z-index: 0;
    pointer-events: none;
  }

  &:hover::before {
    clip-path: circle(75% at 50% 50%);
  }

  & > * {
    position: relative;
    z-index: 1;
  }
  
  // ✅ CAMBIO CLAVE: Se ajusta la altura para tabletas y móviles.
  @media (max-width: 768px) {
    height: 220px;
  }

  @media (max-width: 480px) {
    height: 200px;
  }
`;

export const WidgetLinkWrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%; // Esto ahora funciona predeciblemente gracias a la altura fija del padre.
  color: inherit;
  text-decoration: none;
`;

export const WidgetHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  // ✅ CAMBIO CLAVE: Se reduce el espacio en pantallas pequeñas.
  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const Title = styled.h3`
  font-size: clamp(1rem, 2.5vw, 1.2rem); // clamp() ya es responsivo, excelente.
  font-weight: 600;
  color: ${variables.text};
  margin: 0;
  transition: color 0.3s ease;
  text-align: center;
`;

export const IconWrapper = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg path, svg circle, svg rect, svg g {
    fill: #EF872F !important;
  }

  // ✅ CAMBIO CLAVE: Se reduce el tamaño del ícono en pantallas pequeñas.
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

export const SideSubMenu = styled(motion.div)<{ position?: 'left' | 'right' }>`
  position: absolute;
  top: 0;
  width: 250px;
  background: ${variables.white};
  border-radius: 12px;
  box-shadow: ${variables.shadowHeavy};
  padding: 12px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;

  // Posicionamiento por defecto a la derecha del widget.
  left: calc(100% + 16px);
  right: auto;

  ${({ position }) =>
    position === 'left' &&
    css`
      left: auto;
      right: calc(100% + 16px);
    `}

  // ❌ Se eliminó el media query para 1024px porque era redundante.

  // ✅ Lógica de responsividad para móviles se mantiene, es correcta.
  @media (max-width: 600px) {
    position: fixed; // Se superpone a toda la pantalla
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100vw - 32px); // Ocupa casi todo el ancho con un margen
  }
`;

export const SideSubMenuItem = styled(motion(Link))`
  text-decoration: none;
  font-weight: 500;
  color: ${variables.text};
  padding: 10px 16px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: #f1f3f5;
    color: ${variables.primary};
  }
`;